import { useEffect } from "react";
import type { HomeDashboardState } from "../../application/home-dashboard";
import { SwipeDismissDialog } from "../../ui/components/SwipeDismissDialog";

const format = (value: number) => Math.round(value).toLocaleString("ru-RU");

export function CalorieBalanceDialog({ dashboard, onClose }: { dashboard: HomeDashboardState; onClose: () => void }) {
  useEffect(() => {
    const escape = (event: KeyboardEvent) => { if (event.key === "Escape") onClose(); };
    window.addEventListener("keydown", escape);
    return () => window.removeEventListener("keydown", escape);
  }, [onClose]);
  return <div className="profile-popup-backdrop" onMouseDown={event => { if (event.target === event.currentTarget) onClose(); }}>
    <SwipeDismissDialog className="profile-popup" role="dialog" aria-modal="true" aria-labelledby="balance-title" onDismiss={onClose}>
      <button className="voice-close" type="button" aria-label="Закрыть" onClick={onClose}>×</button>
      <h2 id="balance-title">Расчёт калорий</h2>
      <p className="activity-date">{new Intl.DateTimeFormat("ru-RU", { day: "numeric", month: "long", year: "numeric" }).format(new Date(`${dashboard.date}T12:00:00`))}</p>
      <div className="profile-values">
        <p><span>Дневная цель</span><b>{dashboard.calorieGoal === null ? "Не задана" : `${format(dashboard.calorieGoal)} ккал`}</b></p>
        <p><span>Сожжено дополнительно</span><b>+{format(dashboard.activityCalorieBonus)} ккал</b></p>
        <p><span>Съедено</span><b>−{format(dashboard.eatenCalories)} ккал</b></p>
        {dashboard.calorieGoal !== null && <p><span>{dashboard.remainingCalories < 0 ? "Перерасход" : "Осталось"}</span><b>{format(Math.abs(dashboard.remainingCalories))} ккал</b></p>}
      </div>
      <p className="activity-hint">{dashboard.nutritionIncomplete ? "Итог неполный: калорийность части продуктов ещё не определена." : dashboard.calorieGoal === null ? "Настройте дневную цель, чтобы видеть остаток калорий." : "Осталось = дневная цель + сожжено дополнительно − съедено."}</p>
      <p className="activity-hint">Ручная запись целиком учитывается как дополнительный расход за этот день.</p>
    </SwipeDismissDialog>
  </div>;
}
